import { render, staticRenderFns } from "./CoursePartInputDemo.vue?vue&type=template&id=fbcb0da0"
import script from "./CoursePartInputDemo.vue?vue&type=script&lang=js"
export * from "./CoursePartInputDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports